import * as React from "react";
import "./Icon.css";
const SvgSortIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>
        {
          ".Sort_Icon_svg_cls-1{fill:currentColor;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"
        }
      </style>
    </defs>
    <g transform="translate(1,5)">
      <path
        d="M11.93.5H6.28v29.65H.5l8.61 9.23 8.6-9.23h-5.78zM16.05.5H47.5v8.85H16.05zM23.1 15.83h24.4v8.85H23.1zM31.15 30.53H47.5v8.85H31.15z"
        className="Sort_Icon_svg_cls-1"
      />
    </g>
  </svg>
);
export default SvgSortIcon;
